export let ADVANCED_LOGGING_ENABLED = false;

let myWindow: any = window;

myWindow.setAdvancedLogging = (value: boolean = true) => {
  ADVANCED_LOGGING_ENABLED = value;
  return ADVANCED_LOGGING_ENABLED;
};
